var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"d-inline-block bg-success text-white text-xs p-1",class:_vm.orderProductionLabelClass,domProps:{"innerHTML":_vm._s(_vm.orderProductionLabel)}})])}
var staticRenderFns = []

export { render, staticRenderFns }